module.exports = __webpack_public_path__ + "img/0D0DBD_040497_04047B_040455-256px.eae645e3.png";